/**
 * Organization constants.
 * Single source of truth for contact info, addresses, and identifiers.
 */
export const ORGANIZATION = {
  name: 'The Redd Family Association',
  address: '7906 Montane Run Ct',
  phone: '(301) 325-7909',
  email: 'president@thereddfamily.org',
  taxId: '90-0877869',
  planningCommitteeEmail: 'president@thereddfamily.org',
  zelleContact: {
    name: 'Joseph Davis',
    phone: '(301) 325-7909',
  },
} as const;

/**
 * Single source of truth for the currently featured reunion.
 *
 * To move to a new reunion, update the fields here — the home page, dashboard,
 * admin sidebar, event-detail fallbacks, and contact FAQ all read from this.
 * Calendar dates are floating `YYYY-MM-DD` strings (never converted through UTC).
 *
 * NOTE: The reunion detail page (`/events/<slug>`) is data-driven — its live
 * content comes from the matching event record in the database. The values here
 * are used for the home/dashboard cards and as fallbacks when no record exists.
 */
export const REUNION = {
  slug: 'reunion-2027',
  year: 2027,
  title: 'Reunion 2027',
  tagline: 'Family Reunion Cruise',
  // Cruise specifics
  cruiseLine: 'MSC Seashore',
  departurePort: 'Miami, FL',
  durationLabel: '4 nights / 5 days',
  portsOfCall: ['Nassau, Bahamas', 'Ocean Cay Marine Reserve'],
  cabinTypes: ['Interior Cabin', 'Ocean View', 'Balcony Cabin', 'Grand Suite'],
  // Floating calendar dates — startDate drives the countdown
  startDate: '2027-07-05',
  endDate: '2027-07-09',
  dateLabel: 'July 5–9, 2027',
  // Short one-liner for the home/dashboard cards
  location: 'MSC Seashore · Departs Miami, FL',
} as const;

/**
 * Slug of the currently featured reunion event.
 * Aliased to {@link REUNION.slug} so links stay in sync with the reunion config.
 * The actual event pages use dynamic routing via URL params.
 */
export const CURRENT_REUNION_SLUG = REUNION.slug;
